import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    getCalendarById,
    updateCalendarById,
    getCalendarsByGroupId,
} from "store/slices/calendarSlice";
import { closeModal } from "store/slices/modalsSlice";
import CalendarForm from "./calendar-form";

const EditCalendar = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isModalOpen, modalType, modalProps } = useSelector((state) => state?.modals);
    const { calendar, loading, error } = useSelector((state) => state?.calendars);

    const [serverError, setServerError] = useState(null);
    const open = isModalOpen && modalType === "edit_calendar";

    useEffect(() => {
        if (open && modalProps?.calendarId) {
            dispatch(getCalendarById(modalProps?.calendarId));
        }
    }, [dispatch, modalProps?.calendarId, open]);

    const handleFinish = (values) => {
        if (!modalProps?.calendarId) return;
        setServerError(null);

        dispatch(updateCalendarById({ calendarId: modalProps?.calendarId, data: values }))?.unwrap()?.then(() => {
                // if (values.groupId) {
                //     dispatch(getCalendarsByGroupId(values.groupId._id));
                // }
                modalProps?.handleRefresh && modalProps?.handleRefresh();
                dispatch(closeModal());
            })?.catch((err) => {
                const message =
                    err?.message || err?.error || err?.data?.message || JSON?.stringify(err);
                setServerError(message || t("calendars.form.error.generic", "Une erreur est survenue."));
            });
    };

    const handleCancel = () => dispatch(closeModal());

    return (
        <Modal
            title={t("calendars.edit.title")}
            open={open}
            onCancel={handleCancel}
            footer={null}
            width={800}
            destroyOnClose
        >
            {calendar ? (
                <CalendarForm
                    initialValues={calendar}
                    onFinish={handleFinish}
                    onCancel={handleCancel}
                    loading={loading}
                    error={serverError || error}
                    isEdit={true}
                />
            ) : (
                t("common.loading", "Chargement...")
            )}
        </Modal>
    );
};

export default EditCalendar;
